
      async function boot() {
        // В Vite переменная заменяется на константу на этапе сборки
        const isProd = import.meta.env && import.meta.env.PROD === true
        if (isProd) {
          // Динамически загружаем /config.js и ждём его, чтобы window.__APP_CONFIG__ успел инициализироваться
          await new Promise((resolve) => {
            const s = document.createElement('script')
            s.src = '/config.js'
            s.onload = () => resolve(null)
            s.onerror = () => resolve(null) // даже если файл не найден, продолжаем загрузку приложения
            document.head.appendChild(s)
          })
        }
        // После (в проде — после config.js) загружаем основное приложение
        await import('/src/main.tsx')
      }
      boot()
    